module.exports = __webpack_public_path__ + "img/sketch-green-middle.8345bd06.png";